import styled, { css } from 'styled-components/macro';
import { Row } from '@yme/atoms/grid';
import { MiniButton } from '@yme/atoms/mini-button';
import { colorCoreGray500, colorCoreWhite1000 } from '@yme/tokens/colors';
import { elevationTopLvl4 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { transition300ms } from '@yme/tokens/transitions';
import { Z_INDEX } from '@yme/tokens/zindex';
export const StickyFilterStyled = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${Z_INDEX.level7};
  width: 100%;
  padding: 16px 0;
  background-color: ${colorCoreWhite1000};
  transform: translateY(-100%);
  box-shadow: ${elevationTopLvl4};
  border-bottom: 1px solid ${colorCoreGray500};

  transition: ${transition300ms};

  ${ADAPTIVE.minWidth.tablet} {
    padding: 24px 0;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding-bottom: 0;
    border-bottom: none;
  }

  ${({ isSticky, headerMenuHeight }) => isSticky &&
    css `
      transform: translateY(${headerMenuHeight}px);
    `};
`;
export const RowStyled = styled(Row) `
  align-items: center;
  flex-wrap: nowrap;

  ${ADAPTIVE.minWidth.desktop} {
    align-items: initial;
  }
`;
export const RowContentStyled = styled(Row) `
  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-left: 80px;' : 'margin-right: 80px;')}
`;
export const CollapsingButtonStyled = styled(MiniButton) `
  flex-shrink: 0;
  padding: 12px;
`;
